import { render } from "./matching-card-wrapper.vue?vue&type=template&id=45a204fa&scoped=true&ts=true"
import script from "./matching-card-wrapper.vue?vue&type=script&lang=ts"
export * from "./matching-card-wrapper.vue?vue&type=script&lang=ts"

import "./matching-card-wrapper.vue?vue&type=style&index=0&id=45a204fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a204fa"]])

export default __exports__